<div mat-dialog-title>
  <div style="display: flex; flex-direction: row; gap: 5px; align-items: center; justify-content: flex-start;">
    <mat-icon svgIcon="tune"></mat-icon>
    <span>{{ "columnSettings" | translate }}</span>
  </div>
  <div>
    <button mat-mini-fab color="sims" (click)="resetSettings()" matTooltip="{{ 'resetColumnSettings' | translate }}">
      <mat-icon svgIcon="reset_settings"></mat-icon>
    </button>
  </div>
</div>

<ng-container *ngTemplateOutlet="data.columnsSettings.length > 0 ? selectonEnabled : noColumnsToShow"></ng-container>

<ng-template #selectonEnabled>
  <mat-dialog-content class="dialog-content">
    <div class="wrapper">
      <app-column-hider-list class="w-100" [settings]="data.columnsSettings" [datasource]="data.datasource"
        [columnsSetPreviouslySelected]="data.columsSetId" [frozenColumnsCount]="pendingFrozenColumnsCount"
        [lockedColumnsCount]="data.lockedColumnsCount || 0"
        (frozenColumnsCountChange)="onFrozenColumnsCountChange($event)" (changes)="setColsVisabilityState($event)">
      </app-column-hider-list>

      <app-grouping-column-selector *ngIf="data.groupingEnabled" class="w-100 px" #groupingColumnSelector
        [selectedGroupingColumn]="data.selectedGroupingColumn">
      </app-grouping-column-selector>

      <app-summary-selector *ngIf="data.summaryEnabled" class="w-100 px" [initialState]="data.summaryType" (type)="summaryTypeChange($event)">
      </app-summary-selector>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>{{ "cancel" | translate }}</button>
    <button mat-button (click)="save()" [disabled]="isFormDisabled()" mat-dialog-close>
      {{ "save" | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #noColumnsToShow>
  <mat-dialog-content>
    {{ "no_columns_to_show" | translate | capitalizeFirst}}
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close class="no-columns-to-show-button">
      {{ "close" | translate }}
    </button>
  </mat-dialog-actions>
</ng-template>